var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.035 7.875l.383-2.516H4.984V3.72c0-.711.329-1.367 1.422-1.367h1.121V.192S6.516 0 5.56 0C3.562 0 2.25 1.23 2.25 3.418v1.941H.008v2.516H2.25V14h2.734V7.875h2.051z"
  })));
}
export default SvgFacebookIcon;